import { summariseTrack, type Series, type Track } from '@anytracker/core'

import styles from './Charts.module.css'

/**
 * The summary numbers, taken verbatim from core (T-401).
 *
 * Not one of these is calculated here, and since T-504 not one of them is
 * *worded* here either. `summariseTrack` builds the row, and the printed report
 * renders the same row — so the app and the document someone hands to a doctor
 * cannot disagree about a number or about what to call it, and the person
 * holding both has no reason to wonder which is wrong.
 */
export function StatisticsPanel({
  series,
  track,
}: {
  readonly series: Series
  readonly track: Track
}) {
  const row = summariseTrack(track, series)

  if (row.kind === 'noData') {
    return null
  }

  if (row.kind === 'categorical') {
    return (
      <dl className={styles['stats']}>
        <div>
          <dt>Recorded</dt>
          <dd>{row.count}</dd>
        </div>
        {row.counts.map((count) => (
          <div key={count.label}>
            <dt>{count.label}</dt>
            <dd>{count.count}</dd>
          </div>
        ))}
      </dl>
    )
  }

  return (
    <dl className={styles['stats']}>
      <div>
        <dt>Recorded</dt>
        <dd>{row.count}</dd>
      </div>
      <div>
        <dt>Average</dt>
        <dd>{row.meanLabel}</dd>
      </div>
      <div>
        <dt>Range</dt>
        <dd>{row.rangeLabel}</dd>
      </div>
      <div>
        <dt>Spread</dt>
        <dd>{row.spreadLabel}</dd>
      </div>
      <div>
        {/*
          "Not enough yet" rather than an arrow, when there is not enough. A
          regression through three self-reported readings renders identically to
          one through three hundred.
        */}
        <dt>Trend</dt>
        <dd>{row.trendLabel}</dd>
      </div>
    </dl>
  )
}
